import { isDefined } from "@scalar/helpers/array/is-defined";
//#region src/v2/helpers/generate-location-id.ts
/**
* Generates a unique string ID for an API location, based on the document, path, method, and example.
* Filters out undefined values and serializes the composite array into a stable string.
*
* @param params - An object containing document, path, method, and optional example name.
* @returns A stringified array representing the unique location identifier.
*
* Example:
*   generateLocationId({ document: 'mydoc', path: '/users', method: 'get', example: 'default' })
*   // => '["mydoc","/users","get","default"]'
*/
var generateLocationId = ({ document, path, method, example, isWebhook = false }) => {
	return JSON.stringify([
		document,
		isWebhook ? "webhook" : void 0,
		path,
		method,
		example
	].filter(isDefined));
};
//#endregion
export { generateLocationId };

//# sourceMappingURL=generate-location-id.js.map